<template>
	<v-combobox
		v-model="model"
		:items="items"
		:label="label"
		:outlined="outlined"
		:dense="dense"
		item-text="name"
		item-value="id"
		:hide-details="hideDetails"
		:clearable="clearable"
		:loading="loading"
		:rules="rules"
		return-object
	></v-combobox>
</template>

<script>
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
export default {
	mixins: [mixin],
	props: {
		category:	{ type: Object, default: null },
	},
	watch: {
		category(item) {
			this.onRefresh(item)
		},
	},
	computed: {
		...mapGetters('VehicleDriver', [ 'items' ]),
	},
	methods: {
		...mapActions('VehicleDriver', [ 'load', 'setItems' ]),

		onLoad() {
			if(this.category) {
				this.loading = true;
				this.load({category: this.category}).then(() => {
					this.setDefault();
				}).finally(() => (this.loading = false));
			}
		},
	},
}
</script>